import { createSlice } from "@reduxjs/toolkit"
import {
  addModifierGroups,
  deleteModifierGroupForAll,
  getAllModifierGroups,
  getAllModifierGroupsList,
  getModifierGroupDetails,
  updateModifierGroupStatus,
  updateModifierGroups,
} from "store/actions/modifierGroupAction"

const initialState = {
  loading: true,
  error: null,
  isLoading: false,
  isUpdating: false,
  actionType: null,
  message: null,
  itemsPerPage: 12,
  totalCount: null,
  totalPages: null,
  currentPage: 1,
  modifierGroups: [],
  modifierGroupsList: [],
  modifierGroupDetails: {},
}

const usersSlice = createSlice({
  name: "modifier groups", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    // FETCH ALL MODIFIER GROUPs
    builder
      .addCase(getAllModifierGroups.pending, state => {
        state.loading = true
        state.error = null
        state.actionType = null
      })
      .addCase(getAllModifierGroups.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.modifierGroups = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllModifierGroups.rejected, (state, action) => {
        state.loading = false
      })
    // FETCH ALL MODIFIER GROUPs LIST
    builder
      .addCase(getAllModifierGroupsList.pending, state => {
        state.loading = true
      })
      .addCase(getAllModifierGroupsList.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.modifierGroupsList = data
        }
      })
      .addCase(getAllModifierGroupsList.rejected, (state, action) => {
        state.loading = false
      })
    // ADD MODIFIER GROUP
    builder
      .addCase(addModifierGroups.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(addModifierGroups.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          // console.log(action)
          state.actionType = "" //
        } else {
          state.error = action.payload.msg
          state.actionType = "" //
        }
      })
      .addCase(addModifierGroups.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET MODIFIER GROUP DETAILS
    builder
      .addCase(getModifierGroupDetails.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getModifierGroupDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.modifierGroupDetails = data
        }
      })
      .addCase(getModifierGroupDetails.rejected, (state, action) => {
        state.loading = false
      })
    // UPDATE MODIFIER GROUP
    builder
      .addCase(updateModifierGroups.pending, state => {
        state.error = null
        state.isLoading = true
        state.actionType = null
        state.message = null
      })
      .addCase(updateModifierGroups.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          state.actionType = "UPDATE_MODIFIER_GROUP_SUCCESS"
          state.message = action.payload.msg
        } else {
          state.error = action.payload.msg
          state.actionType = "UPDATE_MODIFIER_GROUP_FAILED"
        }
      })
      .addCase(updateModifierGroups.rejected, (state, action) => {
        state.isLoading = false
      })
    // MODIFIER GROUP STATUS UPDATE
    builder
      .addCase(updateModifierGroupStatus.pending, state => {
        state.error = null
        state.actionType = null
        state.isUpdating = true
      })
      .addCase(updateModifierGroupStatus.fulfilled, (state, action) => {
        state.isUpdating = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.modifierGroups = state.modifierGroups.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
          state.message = action.payload.msg
        } else {
          state.error = action.payload.msg
        }
      })
      .addCase(updateModifierGroupStatus.rejected, (state, action) => {
        state.isUpdating = false
      })

    // DELETE MODIFIER GROUP
    builder
      .addCase(deleteModifierGroupForAll.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteModifierGroupForAll.fulfilled, (state, action) => {
        const { status, msg } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.modifierGroups = state.modifierGroups.filter(
            item => item._id !== id
          )
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteModifierGroupForAll.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
